import pipe from 'ramda/src/pipe'
import map from 'ramda/src/map'
import pluck from 'ramda/src/pluck'
import prop from 'ramda/src/prop'
import includes from 'ramda/src/includes'
import fieldHasError from 'root/src/client/logic/form/selectors/fieldHasError'
import moduleDescriptions from 'root/src/shared/descriptions/modules'

export default (state, { moduleId, moduleKey }) => {
	const formDescription = moduleDescriptions[moduleId]

	if (!prop('fieldSections', formDescription)) return []

	const tabWithFields = pipe(
		prop('fields'),
		map(pluck('fieldId')),
	)(formDescription)
	const tabsWithError = map(pipe(
		map(pipe(
			fieldId => fieldHasError(state, { moduleKey, fieldPath: [fieldId] }),
		)),
		includes(true),
	))(tabWithFields)
	return tabsWithError
}
